// eslint-disable-next-line import/prefer-default-export
export const billUploadDetailEmptyState = {
  Coin: { Symbol_Coin: "₡", Code_Coin: "CRC" },
  Exchange: "1",
  DocumentType: "Factura Electrónica",
};
